import React from "react";
import { NON_PUBLISHING_PLATFORMS, Platform } from "../../types/Platforms";

interface PlatformFilterProps {
  selectedPlatforms: string[];
  onChange: (platforms: string[]) => void;
}

const PlatformFilter: React.FC<PlatformFilterProps> = ({
  selectedPlatforms,
  onChange,
}) => {
  const togglePlatform = (platform: string) => {
    if (selectedPlatforms.includes(platform)) {
      onChange(selectedPlatforms.filter((p) => p !== platform));
    } else {
      onChange([...selectedPlatforms, platform]);
    }
  };

  return (
    <div className="flex flex-col">
      <label className="mb-2 block text-sm font-medium text-theme-fg">
        Platforms
      </label>
      <div className="flex flex-wrap gap-2">
        {/* WordPress is a blog destination and Search Console is a read-only analytics
            connection — neither is a social-post platform, so both are excluded from the
            social-post review filter (WordPress has its own Manage Blogs page). */}
        {Object.values(Platform)
          .filter((platform) => !NON_PUBLISHING_PLATFORMS.includes(platform))
          .map((platform) => (
          <button
            key={platform}
            type="button"
            onClick={() => togglePlatform(platform)}
            className={`px-3 py-1.5 text-sm rounded-full transition-colors ${
              selectedPlatforms.includes(platform)
                ? "bg-brand-primary text-white"
                : "bg-surface-ui text-theme-fg hover:bg-surface-ui-hover"
            }`}
          >
            {getPlatformIcon(platform)}
            <span className="ml-1">{getPlatformDisplayName(platform)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

// Helper function to get platform icons
const getPlatformIcon = (platform: string): JSX.Element => {
  switch (platform) {
    case Platform.FACEBOOK:
      return <i className="fab fa-facebook mr-1" aria-hidden="true"></i>;
    case Platform.INSTAGRAM:
      return <i className="fab fa-instagram mr-1" aria-hidden="true"></i>;
    case Platform.LINKEDIN:
      return <i className="fab fa-linkedin mr-1" aria-hidden="true"></i>;
    case Platform.YOUTUBE_SHORTS:
      return <i className="fab fa-youtube mr-1" aria-hidden="true"></i>;
    case Platform.INSTAGRAM_REELS:
      return <i className="fab fa-instagram mr-1" aria-hidden="true"></i>;
    case Platform.GOOGLE_MY_BUSINESS:
      return <i className="fab fa-instagram mr-1" aria-hidden="true"></i>;
    default:
      return <></>;
  }
};

// Helper function to get friendly platform names
const getPlatformDisplayName = (platform: string): string => {
  switch (platform) {
    case Platform.YOUTUBE_SHORTS:
      return "YouTube Shorts";
    case Platform.INSTAGRAM_REELS:
      return "Instagram Reels";
    default:
      return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
  }
};

export default PlatformFilter;
